import { createSelector } from 'reselect'
// import { List } from 'immutable'

const clientSelector = state => state.get('client')

export const getIsFetching = createSelector(
  clientSelector,
  clientImmutable => {
    const client = clientImmutable.toJS()
    return client.clientList.isFetching
    || client.clientGet.isFetching
    || client.clientEdit.isFetching
    || client.clientCreate.isFetching
    || client.clientDelete.isFetching
  }
)
export const getClientData = createSelector(
  clientSelector,
  clientImmutable => {
    const client = clientImmutable.toJS()
    return client.clientList.clients
  }
)
export const getClientByIDData = createSelector(
  clientSelector,
  clientImmutable => {
    const client = clientImmutable.toJS()
    return client.clientGet.client
  }
)
export const editClientData = createSelector(
  clientSelector,
  clientImmutable => {
    const client = clientImmutable.toJS()
    return client.clientEdit
  }
)
export const createClientData = createSelector(
  clientSelector,
  clientImmutable => {
    const client = clientImmutable.toJS()
    return client.clientCreate
  }
)
export const deleteClientData = createSelector(
  clientSelector,
  clientImmutable => {
    const client = clientImmutable.toJS()
    return client.clientDelete
  }
)
export const redirectClient = createSelector(
  clientSelector,
  clientImmutable => {
    const client = clientImmutable.toJS()
    return ({
      redirect: (client.clientList.redirect
      || client.clientGet.redirect
      || client.clientEdit.redirect
      || client.clientCreate.redirect
      || client.clientDelete.redirect),
      isAuthenticated: (client.clientList.isAuthenticated
      || client.clientGet.isAuthenticated
      || client.clientEdit.isAuthenticated
      || client.clientCreate.isAuthenticated
      || client.clientDelete.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/client/client-master-selector.js